import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const ENTRY_ANIMATION_MS = 600;

/**
 * Promotional bar shown below the header when an unauthenticated user
 * views a public list. Encourages sign-up with a short message and CTA.
 */
const PublicListPromoBar: React.FC = () => {
  const location = useLocation();
  const returnPath = location.pathname + location.search;
  const [playEntryAnimation, setPlayEntryAnimation] = useState(true);

  useEffect(() => {
    const id = setTimeout(() => setPlayEntryAnimation(false), ENTRY_ANIMATION_MS);
    return () => clearTimeout(id);
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center gap-1 px-4 py-3 text-center text-sm sm:text-base bg-gradient-to-r from-amber-100 to-yellow-100 dark:from-amber-900/50 dark:to-amber-950/60 border-y border-amber-300/80 dark:border-amber-600/50 text-gray-900 dark:text-gray-100 shadow-sm"
      role="banner"
    >
      <style>{`
        @keyframes cta-entry {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.06); }
        }
        .cta-entry-animate {
          animation: cta-entry ${ENTRY_ANIMATION_MS}ms ease-out;
        }
      `}</style>
      <div className="font-bold">
        Compare Stocks · Track Every Metric · Share Watchlists
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <span className="italic">All in one place</span>
        <Link
          to="/signup"
          state={{ returnPath, isFromPublicList: true }}
          className={`
            inline-flex items-center font-semibold px-4 py-1.5 rounded-full
            bg-amber-500 dark:bg-amber-500 text-gray-900
            hover:bg-amber-400 dark:hover:bg-amber-400
            focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 focus:ring-offset-amber-100 dark:focus:ring-offset-amber-950
            shadow transition-all duration-200 ease-out
            hover:-translate-y-0.5 hover:shadow-lg
            ${playEntryAnimation ? 'cta-entry-animate' : ''}
          `}
        >
          Get Started Free
        </Link>
      </div>
    </div>
  );
};

export default PublicListPromoBar;
